export const COUNTRIES = [
  "Norway", "Sweden", "Denmark", "Finland", "Iceland", "Germany", "Netherlands",
  "United Kingdom", "Ireland", "France", "Spain", "Italy", "Portugal", "Poland",
  "Switzerland", "Austria", "Belgium", "United States", "Canada", "Australia",
  "India", "Singapore", "United Arab Emirates", "Remote / Any",
];

export const LANGUAGE_LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2", "Native"];

export const COMMON_LANGUAGES = [
  "English", "Norwegian", "Swedish", "Danish", "German", "French", "Spanish",
  "Italian", "Dutch", "Portuguese", "Polish", "Arabic", "Mandarin", "Hindi",
];

export const ARRANGEMENTS = ["remote", "hybrid", "onsite"];

export const REMOTE_SCOPES = ["worldwide", "international", "region", "named_countries", "country", "domestic"];
export const REGIONS = ["EU", "EEA", "EFTA", "Schengen", "Nordics", "Europe", "EMEA", "APAC", "Americas", "International"];
export const OFFICE_FREQUENCIES = ["never", "quarterly", "monthly", "biweekly", "weekly"];
export const TRAVEL_LEVELS = ["none", "occasional", "monthly", "frequent"];
export const EMPLOYMENT_MECHANISMS = ["employee", "contractor", "eor", "freelance"];
export const LOCATION_RATIONALES = [
  "payroll_entity", "tax_social_security", "work_authorization", "labor_law",
  "data_residency", "client_security", "timezone_coverage", "office_need", "internal_policy",
];
export const TIMEZONE_OFFSETS = [-8, -5, -3, 0, 1, 2, 3, 5, 8, 10];

export const EMPLOYMENT_TYPES = [
  "full-time", "part-time", "permanent", "contract", "freelance", "temporary",
];

export const INDUSTRIES = [
  "Research", "Nonprofit", "Customer Service", "Marketing", "Sales", "Data",
  "Healthcare", "Media", "Technology", "Finance", "Education", "International Development",
];

export const ELIGIBILITY_META = {
  eligible: { label: "Eligible", cls: "text-emerald-800 bg-emerald-50 border-emerald-200" },
  possibly_eligible: { label: "Possibly eligible", cls: "text-orange-800 bg-orange-50 border-orange-200" },
  not_eligible: { label: "Not eligible", cls: "text-red-800 bg-red-50 border-red-200" },
};

export const APPLICATION_STATUSES = [
  "interested", "preparing", "applied", "interview", "offer", "rejected", "withdrawn",
];
